import React from 'react';
import { Typography, Tooltip } from '../';
import { InfoCircleOutlined, RightOutlined, DownOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { useCollapse } from '../../hooks';
import './DashboardSection.scss';

const { Title } = Typography;

/**
 * DashboardSection container for sections within the home page
 */
export const DashboardSection = ({ title, children, className = '', tooltip = null, collapsible = true, ...props }) => {
    const [collapsed, toggle] = useCollapse(false);

    return (
        <div className={classNames('panel-wrapper', 'dashboard-section', className)} {...props}>
            <div
                className={classNames('dashboard-section-header', {
                    'dashboard-section-header--clickable': collapsible,
                })}
                onClick={collapsible ? toggle : undefined}
                aria-expanded={collapsible ? !collapsed : undefined}
            >
                <div className="dashboard-title-and-tooltip">
                    <Title level={2} className="semi-bold dashboard-section-title">
                        {title}
                    </Title>
                    {tooltip && (
                        <Tooltip
                            className="dashboard-tooltip"
                            classNames={{ root: 'dashboard-tooltip-content' }}
                            placement="right"
                            title={tooltip}
                        >
                            <InfoCircleOutlined className="dashboard-tooltip-icon" />
                        </Tooltip>
                    )}
                </div>
                {collapsible && (
                    collapsed ? (
                        <RightOutlined className="dashboard-section-caret" />
                    ) : (
                        <DownOutlined className="dashboard-section-caret" />
                    )
                )}
            </div>
            <div className={classNames('dashboard-section-body', { 'dashboard-section-body--collapsible': collapsible, collapsed })}>
                <div className="dashboard-section-content">{children}</div>
            </div>
        </div>
    );
};

export default DashboardSection;
